
// This file is generated by the maven plugin com.axley.js-remodel.  Do not edit!!!


export class GenEventCount {

    abbreviation: string;
    count: number;
    fipsCode: string;
    name: string;
    over12Hours: number;
    over24Hours: number;
    over48Hours: number;
    under12Hours: number;

    constructor();
    constructor( jsonObj: any );
    constructor( genEventCount: GenEventCount);

    constructor( input?: GenEventCount ) {
        if ( input && typeof input !== 'number' ) {
            this.abbreviation = input.abbreviation; // string [string]
            this.count = input.count; // int [number]
            this.fipsCode = input.fipsCode; // string [string]
            this.name = input.name; // string [string]
            this.over12Hours = input.over12Hours; // int [number]
            this.over24Hours = input.over24Hours; // int [number]
            this.over48Hours = input.over48Hours; // int [number]
            this.under12Hours = input.under12Hours; // int [number]
       }
    }

    static jsonResponseToList(arr: any[]): GenEventCount[] {
        if (arr && arr.map) {
          return arr.map(a => new GenEventCount(a));
        } else {
          return [];
        }
    }
}

